/**
 * @file_purpose  component created for logout modal
 * @author Swarnali Ghosh
 * @Date_Created 24-01-2025
 * @Date_Modified 24-01-2025
 */

import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Modal from "react-bootstrap/Modal";
import { removeUserDetails } from '../../redux/slices/UserDetailSlice.js';
import { FormattedMessage } from "react-intl";
import { removeProviderDetails } from '../../redux/slices/ProviderSlice.js';
import { removeCategoryDetails } from '../../redux/slices/changeMenuStateSlice.js';
import { toggleSidebar } from '../../redux/slices/changeMenuStateSlice.js';
import { selectSlider, selectSliderIndex } from '../../redux/slices/ProviderSlice.js';

const LogoutModal = ({ showLogoutModal, handleChangeLogoutModal }) => {

    const dispatch = useDispatch();

    const closeLogoutModal = () => {
        handleChangeLogoutModal()
    }

    const logout = () => {
        dispatch(removeUserDetails(),);
        dispatch(removeProviderDetails());
        dispatch(removeCategoryDetails());
        dispatch(toggleSidebar());
        dispatch(selectSlider());
        dispatch(selectSliderIndex());
        handleChangeLogoutModal();
        // window.location.reload();
    }

    return (
        <>
            <Modal
                show={showLogoutModal}
                onHide={closeLogoutModal}
                backdrop="static"
                centered
            >
                <div className="apply_comp_sec">
                    <Modal.Header closeButton className='py-3'>
                        <h6 className="hed_txt m-0">
                            <FormattedMessage id='LOGOUT' />
                        </h6>
                    </Modal.Header>

                    <div className="">
                        <div className="">
                            <div className="row login-register-form py-4">
                                <div className='not_registered'>
                                    <FormattedMessage id='AREYOUSUREWANTTOLOGOUT' />
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="row">
                        <div className="col-md-10 offset-md-1 save-cancel-btn">
                            <button

                                className="save_btn" style={{ marginRight: 10 }}
                                onClick={logout}
                            >
                                <FormattedMessage id='YES' />
                            </button>
                            <button className="cancel_btn"
                                onClick={closeLogoutModal}
                            >
                                <FormattedMessage id='NO' />
                            </button>
                        </div>
                    </div>

                </div>
            </Modal>
        </>
    )
}

export default LogoutModal
